const createID = () => Math.random().toString(36).substr(2, 9)

const createScaleOption = (label: string, order: number) => ({
  label,
  numericValue: order,
  order,
  scaleOptionID: createID()
})

const createStatement = (label: string, order: number) => ({
  label,
  order,
  statementID: createID()
})

export default {
  likertScale: {
    key: "likertScale",
    label: "Likert Scale",
    data: {
      prompt: "Please rate how much you agree with each statement.",
      description: "<p>Select one response for each statement.</p>",
      showNumbers: false,
      scale: [
        createScaleOption("Strongly disagree", 1),
        createScaleOption("", 2),
        createScaleOption("Neutral", 3),
        createScaleOption("", 4),
        createScaleOption("Strongly agree", 5)
      ],
      statements: [
        createStatement("<p>I understand the goals of this lesson.</p>", 1),
        createStatement(
          "<p>The material in this lesson feels relevant to my work.</p>",
          2
        ),
        createStatement("<p>I feel confident applying what I learned.</p>", 3)
      ]
    }
  }
}
